import {
  RefreshTokenRequest as BRefreshTokenRequest,
  RefreshTokenResponse as BRefreshTokenResponse,
} from '@/services/types/auth-api-service';
import {
  RefreshTokenResponse as TRefreshTokenResponse,
} from '@/transformers/auth/types/token-refresh';
import {
  Transformer,
} from '@/transformers/Transformer';

type Send = string;
type TSend = BRefreshTokenRequest;
type Fetch = BRefreshTokenResponse;
type TFetch = TRefreshTokenResponse;

export class RefreshTokenTransformer extends Transformer<Send, TSend, Fetch, TFetch> {
  public send(data: Send): TSend {
    return {
      refreshToken: data,
    };
  }

  public fetch(data: Fetch): TFetch {
    return data;
  }
}
